import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import BranxasIcon from '/Images/asset1.png';
import XcrowIcon from '/Images/asset2.png';
import BVNKIcon from '/Images/asset3.png'; 
import CheckIcon from '/Images/check.svg'; 
import CardsPlatform from '/Images/CardsPlatform.svg'; 
import { useMediaQuery } from '@mui/material';

const Platform = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const isMobile = useMediaQuery('(max-width: 767px)'); 

  const styles = {
    container: {
      maxWidth: '1290px',
      margin: '0 auto',
      padding: isMobile ? '10px 30px' : '40px 20px', // Adjusted padding for mobile
      background: 'transparent',
    },
    titleSection: {
      textAlign: 'center',
      marginBottom: '30px',
    },
    title: {
      fontSize: isMobile ? '30px' : '40px',
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #FFFFFF 0%, #ACD5ED 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      color: 'transparent',
      marginBottom:"30px"
    },
    subTitleIcons: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row', // Stack items vertically on mobile, horizontally on desktop
      justifyContent: isMobile? 'flex-start':'center',               // Align items to the left
      alignItems: isMobile? 'flex-start':'center',                      // Align items to the top left
      gap: isMobile ? '10px' : '100px',           // Adjusted gap for better spacing
      marginTop: '10px',
      marginBottom: '30px',
      textAlign: 'left', 
      marginLeft:isMobile? "20px":"auto",                // Ensure text aligns to the left
    },
    
    subTitleItem: {
      display: 'flex',
      alignItems: 'center',
      color: '#ffffff',
      fontSize: isMobile ? '1rem' : '1rem',
      textAlign: 'left',                          // Text alignment to the left for each item
      gap: '5px',                                 // Small gap between icon and text
      flexDirection: 'row',                       // Ensures icon and text are side by side
    },
    
    
    
    checkIcon: {
      width: isMobile ? '12px' : '15px',
      height: isMobile ? '12px' : '15px',
      marginRight: '5px',
    },
    cardContainer: {
      display: 'flex', // Use flex for better wrapping on small screens
      flexDirection: isMobile ? 'column' : 'row', // Stack vertically on mobile
      flexWrap: 'wrap', // Allow cards to wrap
      justifyContent: isMobile ? 'center' : 'space-between', // Center on mobile
      gap: '20px',
    },
    card: {
      paddingTop: isMobile ? '100px' : '20px',   // Top padding
      paddingBottom: isMobile ? '150px' : '10px', // Bottom padding
      paddingLeft: isMobile ? '15px' : '10px',   // Left padding
      paddingRight: isMobile ? '15px' : '10px',  // Right padding
      borderRadius: '10px',
      backgroundImage: `url(${CardsPlatform})`,
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      width: isMobile ? '100%' : '402px', // Full width on mobile
      maxWidth: isMobile ? '400px' : '402px', // Set max width to prevent overflow
      height: isMobile ? 'auto' : '500px', // Auto height for flexible content sizing
      margin: '0 auto', // Center the card horizontally
      position: 'relative',
      overflow: 'hidden',
    },
    icon: {
      width: isMobile ? '40px' : '70px', // Smaller icon on mobile
      height: isMobile ? '40px' : '70px',
      color: '#F4E37B',
      marginBottom: '20px',
      marginTop: isMobile ? '0px' : '70px',
    },
    cardTitle: {
      color: '#F4E37B',
      fontSize: isMobile ? '16px' : '22px', // Adjusted font size for mobile
      fontWeight: '600',
      marginBottom: '10px',
    },
    cardText: {
      maxWidth: '307px',
      color: '#FFFFFF',
      fontSize: isMobile ? '0.75rem' : '1rem', // Reduced font size on mobile
      lineHeight: '1.5',
      textAlign: 'center',
      margin: '0 auto',
    },
  };

  const platforms = [
    {
      iconSrc: BranxasIcon,
      title: 'Secure Asset Protection',
      text: 'Our advanced infrastructure ensures your digital assets are safeguarded with the highest security standards, offering peace of mind for your most valuable holdings.',
      delay: 0, // Start immediately
    },
    {
      iconSrc: XcrowIcon,
      title: 'Trusted Solutions',
      text: 'Our commitment to transparency and trust provides you with clear, reliable oversight, ensuring all your operations are handled with the utmost integrity and precision.',
      delay: 200, // 500ms delay for the second card
    },
    {
      iconSrc: BVNKIcon,
      title: 'Transaction Efficiency',
      text: 'Experience smooth and reliable transactions with a streamlined process designed to minimize friction and maximize convenience in every exchange.',
      delay: 500, // 1000ms delay for the third card
    },
  ];
  

  return (
    <section style={{ 
      background: 'radial-gradient(circle at center top, #0582CA 0%, #0972B0 13%, #0E6197 21%, #0D527E 27%, #134264 37%, #16324A 100%)',
      padding: isMobile ? '2rem 0' : '4rem 0',
      fontFamily: "Poppins",
    }}>
      <div style={styles.container}>
        {/* Title Section */}
        <div style={styles.titleSection}>
          <h2 style={styles.title}>
            Trustworthy Solutions for Your Digital Needs
          </h2>
          <div style={styles.subTitleIcons}>
            <div style={styles.subTitleItem}>
              <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
              <span>Support blockchains</span>
            </div>
            <div style={styles.subTitleItem}>
              <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
              <span>API-ready</span>
            </div>
            <div style={styles.subTitleItem}>
              <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
              <span>Natively compatible with the Web3 ecosystem</span>
            </div>
            <div style={styles.subTitleItem}>
              <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
              <span>White-label Solutions</span>
            </div>
          </div>
        </div>

        {/* Card Section */}
        <div style={styles.cardContainer}>
          {platforms.map((platform, index) => (
            <div 
              key={index} 
              style={styles.card} 
              data-aos="fade-up" 
              data-aos-delay={platform.delay}
            >
              <img src={platform.iconSrc} alt={platform.title} style={styles.icon} />
              <h3 style={styles.cardTitle}>{platform.title}</h3>
              <p style={styles.cardText}>{platform.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Platform;
